module.exports = __webpack_public_path__ + "static/media/cesgs-logo-only.42d3923f.png";